// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6l290"};